/**
 * Create a conditional-discount promotion: name, image, minValue condition, per-product discounts.
 * @param {Function} requestWithMeta - useHttp().requestWithMeta
 * @param {{ name: string, imageUrl: string | null, minValue: number, rewards: Array<{ productId: number|string, discount: number }> }} payload
 * @returns {Promise<{ ok: boolean, data?: any, status?: number }>}
 */
export async function createConditionalDiscountPromotion(requestWithMeta, payload) {
  const { name, imageUrl, minValue, rewards } = payload;

  const trimmedName = name?.trim() ?? '';
  const numericMin = Number(minValue);

  const rewardsClean = Array.isArray(rewards)
    ? rewards
        .filter((r) => r.productId != null && Number(r.discount) > 0)
        .map((r) => ({
          productId: r.productId,
          discount: Number(r.discount),
        }))
    : [];

  const body = {
    name: trimmedName,
    imageUrl: imageUrl?.trim?.() || null,
    conditions: [
      {
        typeId: 1, // CONDITIONAL
        metaData: {
          minValue: numericMin,
        },
      },
    ],
    rewards: rewardsClean,
  };

  const res = await requestWithMeta('/operator/promotions', 'POST', body);
  return { ok: res?.ok ?? false, data: res?.data, status: res?.status };
}

